import { CubeTransparentIcon } from "@heroicons/react/24/outline";

const NoInvoicesDisclaimer = () => {
  return (
    <div className="mt-5 flex flex-col items-center justify-center text-center bg-yellow-50 border border-yellow-200 rounded-xl p-6 shadow-sm">
      <CubeTransparentIcon className="h-10 w-10 text-yellow-500 mb-4" />
      <h2 className="text-lg font-semibold text-yellow-800 mb-2">
        No Invoice Data Available
      </h2>
    </div>
  );
};

export default NoInvoicesDisclaimer;
